module.exports = __webpack_public_path__ + "img/glitter_10.5a6e69b7.jpg";